/**
 * Sends MY ip address from this computer
 * @returns {string} ip address
 */
export default class GetIP {
    init = async(url) => {
        try {
            const PostRequest = {
                "command": "getip",
                "data": ""
            }
            const requestOptions = {    
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(PostRequest)
            };
            var data = await fetch(url, requestOptions);
            const response = await data.json();
            return response.message;
        } catch(e) {
            return "error: " + e.toString();
        }
    }
}
